// ResetAuthUserButton.js
import { useRecordContext, useNotify, Button } from 'react-admin';
import { supabaseClient } from './supabase';
import {
  FunctionsHttpError,
  FunctionsRelayError,
  FunctionsFetchError,
} from '@supabase/supabase-js';

export const ResetAuthUserButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const handleResetUser = async () => {
    const { error: resetUserError } = await supabaseClient.functions.invoke(
      'resetAuthUser',
      {
        body: {
          id: record.authid,
          email: record.email,
        },
      }
    );
    if (resetUserError instanceof FunctionsHttpError) {
      const errorMessage = await resetUserError.context.json();
      console.log(`resetAuthUser return an error: ${errorMessage}`);
      notify(`Error resetting user: ${resetUserError}`, { type: 'error' });
      return false;
    } else if (resetUserError instanceof FunctionsRelayError) {
      console.log(`Relay error: ${resetUserError.message}`);
      notify(`resetAuthUser relay error: ${resetUserError.message}`, {
        type: 'error',
      });
    } else if (resetUserError instanceof FunctionsFetchError) {
      console.log(`Fetch error: ${resetUserError.message}`);
      notify(`resetAuthUser fetch error: ${resetUserError.message}`, {
        type: 'error',
      });
    }
    console.log(`Successfully reset user: ${record.email}`);
    notify(`Successfully reset user: ${record.email}`, { type: 'success' });
  };
  return (
    <Button
      sx={{
        padding: '12px 24px',
        color: '#D9D9D9',
        fontWeight: 'bold',
        fontSize: '12pt',
        backgroundColor: '#ab261d',
        '&:hover': {
          backgroundColor: '#d63024',
        },
      }}
      onClick={handleResetUser}
    >
      {record.invited_at ? 'Reset User' : 'Invite User'}
    </Button>
  );
};
